import { envConfig } from "@env/env-config";
import type { IPreference } from "@modules/partner/model/domain/preference";
import type { ICurrencyObj } from "@modules/main/header/header";

/**
 * @desc 操作偏好数据
 */
interface IPreferenceStore {
    /**
     * @desc 初始化, 在$onInit里调用
     * @param currentPreference
     */
    use(currentPreference: IPreference): void;
    /**
     * @desc 更新
     * @param currentPreference
     */
    updatePreference(
        currentPreference: Partial<IPreference>
    ): void;
}
/**
 * @private
 */
interface IPreferenceStoreInternal {
    /**
     * @desc 读取偏好
     * @param currentPreference 获取的偏好的数据源
     */
    getPreferenceControl(currentPreference: IPreference): IPreference;
    /**
     * @desc 写入偏好
     * @param currentPreference 写入的偏好的数据源
     */
    setPreferenceControl(
        currentPreference: IPreference
    ): void;
}
/**
 * @desc 偏好编辑器接口定义
 */
export interface IPreferenceEditorService extends IPreferenceStore {
    /**
     * @desc 用户偏好(state)
     */
    userPreference: IPreference;
    /**
     * @desc 打开偏好设置弹窗
     */
    openPreferenceEditor<Ret>(
        $uibModal: angular.ui.bootstrap.IModalService,
        resolve: Record<string, any>
    ): angular.IPromise<Ret>;
    /**
     * @desc 打开偏好设置弹窗, 包含自定义配置
     */
    openPreferenceEditor<Ret>(
        $uibModal: angular.ui.bootstrap.IModalService,
        resolve: Record<string, any>,
        customizeOptions: angular.ui.bootstrap.IModalSettings
    ): angular.IPromise<Ret>;
    diff<T extends ICurrencyObj>(currencyObj: T): boolean;
}
export class PreferenceEditorService implements IPreferenceEditorService, IPreferenceStoreInternal {
    public static readonly $inject: string[] = [];
    private static DEFAULT_PREFERENCE: Readonly<IPreference> = Object.freeze({
        currencyCode: envConfig.defaultCurrency(),
    });
    public userPreference: IPreference = {
        ...PreferenceEditorService.DEFAULT_PREFERENCE,
    };
    constructor() {
        // console.log("constructor preferenceEditorService", this);
    }

    public use(currentPreference: IPreference) {
        this.setPreferenceControl(
            this.getPreferenceControl(currentPreference)
        );
    }

    public updatePreference(
        currentPreference: IPreference
    ): void {
        this.setPreferenceControl(currentPreference);
    }

    getPreferenceControl(
        this: PreferenceEditorService,
        currentPreference?: IPreference
    ): IPreference {
        const basePreference: Partial<IPreference> = {};
        // CurrencyCode

        // console.log("do get currentCurrencyCode", currentPreference?.currencyCode);
        if (!currentPreference?.currencyCode || currentPreference.currencyCode === "null") {
            // 没有定义(也可能是第一次访问)
            /**
             * @date 2024-12-31
             * @comment 这里复制从默认值改为空字符串, 表示为 从不显示到显示
             */
            basePreference.currencyCode = "";
        } else {
            basePreference.currencyCode = currentPreference.currencyCode;
        }
        // @ts-expect-error -- 类型实际为正确
        return basePreference;
    }

    setPreferenceControl(
        this: PreferenceEditorService,
        currentPreference: IPreference
    ): void {
        // console.log("do set currentCurrencyCode", currentPreference?.currencyCode);
        /**
         * @date 2024-12-31
         * @comment 移除对 storage 的修改
         */
        // CurrencyCode
        // 防止错误的赋值
        if (currentPreference.currencyCode) {
            this.userPreference = currentPreference;
        }
    }
    public openPreferenceEditor = (
        $uibModal: angular.ui.bootstrap.IModalService,
        resolve: Record<string, any>,
        customizeOptions?: angular.ui.bootstrap.IModalSettings
    ): angular.IPromise<any> => {
        const modalInstance = $uibModal.open({
            component: "preferenceEditorComponent",
            backdrop: "static",
            ...customizeOptions,
            resolve,
        });
        // receive selectedItem
        return modalInstance.result;
    };
    private Transduce_Map = Object.seal({
        currencyCode: "code",
    });
    public diff(currencyObj: ICurrencyObj): boolean {
        let version: number = 0;
        Object.entries(this.Transduce_Map).forEach(([key, value]) => {
            if (this.userPreference[key] !== currencyObj[value]) {
                version++;
            }
        });
        return Boolean(version);
    }
}
